import scrollToSection from './scroll-to-section'

class Tabs {
  /**
   * Constructor
   *
   * @param {Element} el HTML element
   */
  constructor(el) {
    this.container = el
    this.tabs = this.container.querySelectorAll('[data-action="tab"]')
    this.items = this.container.querySelectorAll('.tabs__menu__item')
    this.panels = this.container.querySelectorAll('.tabs__panel')

    if (this.tabs && this.panels) {
      this.init()
    }
  }

  reset() {
    this.panels.forEach(panel => {
      panel.classList.remove('tabs__panel--active')
    })
    this.items.forEach(item => {
      item.classList.remove('tabs__menu__item--active')
    })
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault()
        const { panel } = tab.dataset
        const target = this.container.querySelector(`#${panel}`)
        const tabButton = this.container.querySelector(`[data-panel="${panel}"]`)
        const item = tabButton ? tabButton.closest('.tabs__menu__item') : null

        if (target && item) {
          this.reset()
          target.classList.add('tabs__panel--active')
          item.classList.add('tabs__menu__item--active')
        }

        scrollToSection.scroll(this.container)
        e.stopPropagation()
      })
    })
  }
}

const tabsInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.tabs')
    Array.from(wrapperEl).forEach(el => {
      // eslint-disable-next-line no-new
      new Tabs(el)
    })
  },
}

export default tabsInit
